<template>
  <div class="hot-table-edit-features">
    <b-modal
      :active="is_edit_feature"
      scroll="keep"
      @close="is_edit_feature = false"
    >
      <div class="card" style="border-radius: 1rem">
        <div class="card-content" style="padding: 10px">
          <!-- <i
            class="fa fa-arrow-right is-pointer"
            v-if="sorting == 'asc'"
            @click="sorting = 'desc'"
            aria-hidden="true"
            v-tooltip="'left to right'"
          ></i>
          <i class="fa fa-arrow-left is-pointer" @click="sorting = 'asc'" v-else aria-hidden="true" v-tooltip="'right to left'"></i>
          <p style="margin-top: 10px"></p> -->

          <div style="margin-bottom: 10px">
            Sorting ::
            <select v-model="sorting_type">
              <option value="vertical">Vertical</option>
              <option value="horizontal">Horizontal</option>
            </select>
            <select style="margin-left: 10px" v-model="sorting_order">
              <template v-if="sorting_type == 'vertical'">
                <option value="desc">Top to bottom</option>
                <option value="asc">Bottom to top</option>
              </template>
              <template v-else>
                <option value="asc">Left to right</option>
                <option value="desc">Right to left</option>
              </template>
            </select>
          </div>

          <div
            v-if="is_loading"
            class="has-text-centered"
            style="height: 50vh; padding-top: 5rem"
          >
            <i class="fa fa-spinner fa-spin"></i>
          </div>
          <hot-table
            v-else
            ref="hotTableComponent"
            class="has-slimscroll-xs"
            height="450"
            width="650"
            :licenseKey="'db092-91fce-a1a62-ecb33-e755b'"
            :settings="hotSettings"
            :data="filtered"
            :columns="columns"
            :colHeaders="colHeaders"
            :columnSorting="{
              sortEmptyCells: true,
            }"
            :manualColumnFreeze="true"
            :fixedColumnsLeft="1"
            :allowInsertColumn="true"
            :manualColumnResize="true"
          />
          <div class="bottom-buttons">
            <div class="is-flex">
              <div
                v-if="is_edit_enabled"
                class="button"
                style="margin-right: 10px"
                @click="
                  () => {
                    $refs.csvFileInput.click();
                  }
                "
              >
                Import
              </div>
              <div class="button" @click="onExportClicked">Export</div>
            </div>
            <div class="is-flex">
              <div
                class="button"
                style="margin-right: 10px"
                @click="is_edit_feature = false"
              >
                Cancel
              </div>
              <div
                class="button is-primary"
                :disabled="!is_edit_enabled"
                @click="saveChanges"
              >
                Save
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <input
      ref="csvFileInput"
      style="visibility: hidden"
      type="file"
      accept=".csv"
      @change="onImportInputChange"
    />
  </div>
</template>

<script>
import { HotTable } from "@handsontable/vue";
import { mapState } from "vuex";
import ApiService from "../../../api.service";
const apiService = new ApiService();
export default {
  components: { HotTable },
  data() {
    return {
      sorting_type: "vertical",
      sorting_order: "asc",
      sorting: "asc",
      is_loading: true,
      is_rename_column: false,
      is_new_column: false,
      old_column_name: "",
      column_name: "",
      is_edit_feature: false,
      data: [],
      key: 1,
      colHeaders: [],
      columns: [],
      centroid_map: {},
      hotSettings: {
        copyPaste: {
          columnsLimit: 10000,
          rowsLimit: 9999999,
        },
        allowInsertColumn: true,
        // afterChange: this.saveChanges,
        // dropdownMenu: {
        //   items: {
        //     rename: {
        //       name: "Rename",
        //       callback: this.rename_column,
        //     },
        //     delete: {
        //       name: "Delete",
        //       callback: this.delete_column,
        //     },
        //     add_new_column: {
        //       name: "Insert column",
        //       callback: (key, selection, clickEvent) => {
        //         this.is_new_column = true;
        //       },
        //     },
        //   },
        // },
      },
    };
  },
  created() {
    document.addEventListener("click", (event) => {
      event.stopPropagation();
      if (
        event.target.id == "btn-edit" ||
        (event.target.parentNode && event.target.parentNode.id == "btn-edit")
      ) {
        let features = this.draw.getSelected().features;
        if (features.length > 1) {
          this.is_edit_feature = true;
          this.is_loading = true;
          setTimeout(() => {
            this.centroid_map = {};
            this.data = [];
            this.colHeaders = [
              "uid",
              "temperature_difference",
              "timestamp",
              "string_number",
              "modified_string_number",
              "serial_number",
              "temperature_min",
              "temperature_max",
              "yield_loss_estimate",
              "power_loss_estimate",
              "adjusted_delta_temperature",
              "num_modules_affected",
              "latitude",
              "longitude",
              "comment",
            ];
            this.columns = [];
            this.colHeaders.forEach((el) => {
              this.columns.push({
                data: el,
                readOnly: el === "uid",
              });
            });
            features.forEach((f) => {
              this.data.push({
                uid: f.properties.uid,
                temperature_difference: f.properties.temperature_difference,
                timestamp: f.properties.timestamp,
                string_number: f.properties.string_number,
                modified_string_number: f.properties.modified_string_number,
                temperature_min: f.properties.temperature_min,
                temperature_max: f.properties.temperature_max,
                yield_loss_estimate: f.properties.yield_loss_estimate,
                power_loss_estimate: f.properties.power_loss_estimate,
                serial_number: f.properties.serial_number,
                adjusted_delta_temperature:
                  f.properties.adjusted_delta_temperature,
                num_modules_affected: f.properties.num_modules_affected,
                latitude:
                  f.properties.center &&
                  f.properties.center[0] &&
                  f.properties.center[0][1],
                longitude:
                  f.properties.center &&
                  f.properties.center[0] &&
                  f.properties.center[0][0],
                comment: f.properties.comment,
              });
              this.centroid_map[f.properties.uid] =
                turf.centroid(f).geometry.coordinates;
            });

            this.is_loading = false;
          }, 0);
        }
      }
    });
  },
  computed: {
    ...mapState(["draw", "container", "active_project", "claims"]),
    is_edit_enabled() {
      return (
        this.claims &&
        this.claims.user_role &&
        ["hacker", "manager_team", "gis_team"].includes(
          this.claims.user_role.name
        )
      );
    },

    filtered() {
      let index_to_use = this.sorting_type === "horizontal" ? 0 : 1;
      // TODO: fix this
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.data.sort((a, b) => {
        if (this.sorting_order == "asc")
          return (
            this.centroid_map[a.uid][index_to_use] -
            this.centroid_map[b.uid][index_to_use]
          );
        return (
          this.centroid_map[b.uid][index_to_use] -
          this.centroid_map[a.uid][index_to_use]
        );
      });
    },
    // filtered() {
    //   return this.data.sort((a, b) => {
    //     if (this.sorting == "asc") return this.centroid_map[a.uid][0] - this.centroid_map[b.uid][0];
    //     return this.centroid_map[b.uid][0] - this.centroid_map[a.uid][0];
    //   });
    // },
  },
  methods: {
    saveChanges() {
      let data = _.cloneDeep(this.data);

      data = data.map((f) => {
        f.issueUID = f.uid;
        if (f.latitude || f.longitude) f.center = [[f.longitude, f.latitude]];
        delete f.uid;
        delete f.latitude;
        delete f.longitude;
        return f;
      });

      apiService
        .post(`internal/bulk/features/?viewUid=${this.$route.params.uid}`, data)
        .then((res) => {
          let response = _.keyBy(this.data, "uid");
          let fc = this.draw.getSelected();
          fc.features = fc.features.map((f) => {
            if (response[f.properties.uid]) {
              f.properties = {
                ...f.properties,
                ...response[f.properties.uid],
              };
            }
            return f;
          });

          this.draw.add(fc);
          this.$toast.open("Saved successfully");
          this.is_edit_feature = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.open(`Failed to save changes. Error: ${err}`);
        });
    },
    onImportInputChange(event) {
      if (
        !window.File ||
        !window.FileReader ||
        !window.FileList ||
        !window.Blob
      ) {
        console.log("The File APIs are not fully supported in this browser.");
        return;
      }

      if (!event.target.files) {
        console.log(
          "This browser doesn't seem to support the `files` property of file inputs."
        );
      } else if (!event.target.files[0]) {
        console.log("No file selected.");
      } else {
        let file = event.target.files[0];
        let fr = new FileReader();
        fr.onload = () => {
          const cell_contents = fr.result
            .replace(/\r/g, "")
            .replace(/\n/g, ",")
            .split(",");
          const chunked_array = _.chunk(cell_contents, 15);
          console.log(chunked_array);
          const result = _.chain(chunked_array)
            .map((p) => {
              return _.zipObject(
                [
                  "uid",
                  "temperature_difference",
                  "timestamp",
                  "string_number",
                  "modified_string_number",
                  "serial_number",
                  "temperature_min",
                  "temperature_max",
                  "yield_loss_estimate",
                  "power_loss_estimate",
                  "adjusted_delta_temperature",
                  "num_modules_affected",
                  "latitude",
                  "longitude",
                  "comment",
                ],
                p
              );
            })
            .value();
          this.$refs.hotTableComponent.hotInstance.loadData(result);
        };
        fr.readAsText(file);
      }
    },
    onExportClicked() {
      const hot = this.$refs.hotTableComponent.hotInstance;
      const exportPlugin = hot.getPlugin("exportFile");
      exportPlugin.downloadFile("csv", { filename: "export" });
    },
  },
};
</script>

<style lang="scss">
@import "~handsontable/dist/handsontable.full.css";
</style>

<style lang="scss" scoped>
::v-deep .modal .modal-content {
  width: 670px;
}

.bottom-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
</style>
